module.exports = __webpack_public_path__ + "img/np.4add163e.png";